// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AnonymousForSalePropertyAgent",
    "VisibleForSalePropertyAgent"
  ]);
}

let fragmentConverter = {"__root":{"agentV2_VisibleForSalePropertyAgent_agent":{"f":""},"agentV2":{"u":"fragment_agentV2"},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_agentV2: unwrap_fragment_agentV2
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function membershipStatusV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "TERMINATED") {
    return $$enum;
  }
}

let membershipStatusV5_fromString = membershipStatusV5_decode;

let Utils = {
  membershipStatusV5_decode: membershipStatusV5_decode,
  membershipStatusV5_fromString: membershipStatusV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "kind": "RequiredField",
  "field": {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "membershipStatus",
    "storageKey": null
  },
  "action": "THROW"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactForSalePropertyAgentButton_forSalePropertyV5",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UseShouldShowPropertyDetails_propertyV5"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "agentV2",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ContactAgentButton_agent"
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                "action": "THROW"
              }
            ],
            "type": "VisibleForSalePropertyAgent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/)
            ],
            "type": "AnonymousForSalePropertyAgent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
};
})());

let wrap_fragment_agentV2 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_agentV2 = unwrap_fragment_agentV2;
exports.wrap_fragment_agentV2 = wrap_fragment_agentV2;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
